module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.btnText) + "\n    \t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "image/gif, image/jpg, image/jpeg, image/png, image/bmp"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block",
      "margin-left": "20px"
    }
  }, [_vm._v("300x100  最大3M")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010e733b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UploadFile.vue
// module id = 693
// module chunks = 1